<template>
    <form @submit="onSubmit">
        <div class="billing-addr" v-if="lang=='fr'">
            <div class="progress">
                <h1>Votre Panier</h1>
                <div>Votre commande</div>
                <div class="active">Facturation et livraison</div>
                <div>Récapitulatif</div>
            </div>
            <div>
                <div>
                    <strong>Adresse de facturation</strong><br />
                    Merci de remplir le formulaire ci-dessous.<br />
                    <small>La facture sera établie automatiquement aux coordonnées de facturation (et jointe à votre colis s'il ne s'agit pas d'un cadeau).</small>
                </div>

                <div class="form">
                    <ul>
                        <li>
                            <label>Nom</label>
                            <select v-model="billingAddress.gender">
                                <option v-for="gender in all_genders" :value="gender.type">{{ gender.fr }}</option>
                            </select>
                            <input type="text" required v-model="billingAddress.lname" />
                        </li>
                        <li>
                            <label>Prénom</label>
                            <input type="text" required v-model="billingAddress.fname"  />
                        </li>
                        <li>
                            <label>Société</label>
                            <input type="text" v-model="billingAddress.company" />
                        </li>
                        <li>
                            <label>N° de TVA intracommunautaire</label>
                            <input type="text" v-model="billingAddress.vat" />
                        </li>
                        <li class="address">
                            <label>Adresse</label>
                            <textarea required v-model="billingAddress.address" ></textarea>
                        </li>
                        <li>
                            <label>Code Postal</label>
                            <input required type="text" v-model="billingAddress.postcode" />
                            <span class="city">Ville : </span>
                            <input type="text" required v-model="billingAddress.city" />
                        </li>
                        <li>
                            <label>Pays</label>
                            <select required v-model="billingAddress.country">
                                <option v-for="country in all_countries"  :value="country.type">{{ country.fr }}</option>
                            </select><span class="other-country">Pour tout autre pays, contactez directement AIM</span>
                        </li>
                        <li>
                            <label>N° de téléphone</label>
                            <input required type="text" v-model="billingAddress.phone" />
                        </li>
                        <li>
                            <label>Email</label>
                            <input required type="email" v-model="billingAddress.email" />
                        </li>
                        <li>
                            <label>Confirmez votre email</label>
                            <input  type="email" v-model="billingAddress.email_confirm"/>
                        </li>
                    </ul>
                </div>

            </div>
            <section class="actions">
                <button @click="prevStep()" class="prev submit focus">Retour</button>
                <button @click="nextStep()" class="next submit focus">Valider</button>
            </section>
        </div>

        <div class="billing-addr" v-else>
            <div class="progress">
                <h1>Your shipping cart</h1>
                <div>Your order</div>
                <div class="active">Billing and Shipping Addresses</div>
                <div>Summary</div>
            </div>
            <div class="client-page">
                <p>
                    <strong>Billing Address</strong><br />
                    Thank you for filling out the form bellow.<br />
                    <small>We will automatically send the issued invoice to your billing address (the invoice will be included in your parcel unless you specify it is a gift).</small>
                </p>

                <div class="form">
                    <ul>
                        <li>
                            <label>Last Name</label>
                            <select v-model="billingAddress.gender">
                                <option v-for="gender in all_genders" :value="gender.type">{{ gender.en }}</option>
                            </select>
                            <input type="text" required v-model="billingAddress.lname" />
                        </li>
                        <li>
                            <label>First Name</label>
                            <input type="text" required v-model="billingAddress.fname" />
                        </li>
                        <li>
                            <label>Company</label>
                            <input type="text" v-model="billingAddress.company" />
                        </li>
                        <li>
                            <label>VAT Number</label>
                            <input type="text" v-model="billingAddress.vat"  />
                        </li>
                        <li class="address">
                            <label>Address</label>
                            <textarea required v-model="billingAddress.address" ></textarea>
                        </li>
                        <li>
                            <label>Zip Code</label>
                            <input required type="text" v-model="billingAddress.postcode" />
                            <span class="city">City :</span>
                            <input type="text" required v-model="billingAddress.city" />
                        </li>
                        <li>
                            <label>Country</label>
                            <select required v-model="billingAddress.country">
                                <option v-for="country in all_countries"  :value="country.type">{{ country.en }}</option>
                            </select><span class="other-country">For any other country, please contact Amelie</span>
                        </li>
                        <li>
                            <label>Telephone number</label>
                            <input required type="text" v-model="billingAddress.phone"  />
                        </li>
                        <li>
                            <label>Email</label>
                            <input required type="email" v-model="billingAddress.email" />
                        </li>
                        <li>
                            <label>Confirm your email</label>
                            <input  type="email" v-model="billingAddress.email_confirm" />
                        </li>
                    </ul>

                </div>
            </div>
            <section class="actions">
                <button @click="prevStep()" class="prev submit focus">Retour</button>
                <button @click="nextStep()" class="next submit focus">Valider</button>
            </section>
        </div>
    </form>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Client',
    props: ['lang'],
    data() {
      return {
        goingBack: false,
        all_genders: [
          { type: 'M', fr: 'Mr', en: 'Mr.' },
          { type: 'Mme', fr: 'Mme', en: 'Mrs' },
          { type: 'Mlle', fr: 'Mlle', en: 'Ms.' },
        ],
        all_countries: [
          { type: 'FR', fr: 'France métropolitaine', en: 'France' },
          { type: 'GB', fr: 'Royaume Uni', en: 'United Kingdom' },
          { type: 'IT', fr: 'Italie', en: 'Italy' },
          { type: 'DE', fr: 'Allemagne', en: 'Germany' },
          { type: 'ES', fr: 'Espagne', en: 'Spain' },
          { type: 'CH', fr: 'Suisse', en: 'Switzerland' },
          { type: 'AT', fr: 'Autriche', en: 'Austria' },
          { type: 'SE', fr: 'Suède', en: 'Sweden' },
          { type: 'NO', fr: 'Norvège', en: 'Norway' },
        ],
        errors: [
        ],
      };
    },
    computed: {
      ...mapGetters([
        'billingAddress',
        'shippingAddress',
      ]),
    },
    methods: {
      prevStep() {
        this.goingBack = true;
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Checkout${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      nextStep() {
        this.goingBack = false;

        if (!this.checkForm()) {
          return;
        }

        this.$store.commit('updateBillingAddress', this.billingAddress);

        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Shipping${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      onSubmit(e) {
        e.preventDefault();

        if (this.checkForm() && !this.goingBack) {
          this.nextStep();
        }
      },
      checkForm() {
        this.errors = [];

        if (!this.billingAddress.fname) {
          this.errors.push(this.lang === 'fr' ? 'Prénom' : 'First name');
        }

        if (!this.billingAddress.lname) {
          this.errors.push(this.lang === 'fr' ? 'Nom' : 'Last name');
        }

        if (!this.billingAddress.address) {
          this.errors.push(this.lang === 'fr' ? 'Adresse' : 'Address');
        }

        if (!this.billingAddress.postcode) {
          this.errors.push(this.lang === 'fr' ? 'Code postal' : 'Zip code');
        }

        if (!this.billingAddress.country) {
          this.errors.push(this.lang === 'fr' ? 'Pays' : 'Country');
        }

        if (!this.billingAddress.phone) {
          this.errors.push(this.lang === 'fr' ? 'Téléphone' : 'Phone');
        }

        if (!this.billingAddress.email) {
          this.errors.push(this.lang === 'fr' ? 'Email' : 'Email');
        }

        if (!this.billingAddress.email_confirm
          || this.billingAddress.email !== this.billingAddress.email_confirm) {
          this.errors.push(this.lang === 'fr' ? 'Email confirmation' : 'Confirm email');
        }

        if (this.errors.length === 0) {
          return true;
        }
        return false;
      },
    },
  };
</script>


<style lang="scss">
    .billing-addr {
        padding: 2rem !important;
        max-width: 900px;
        background: url('../assets/checkout_bg.png') no-repeat top;
        background-size: cover;
        margin:auto;
        color: #654a45;

        .progress {
            color:white;
            counter-reset: progress-counter;

            @media (max-width:42rem) {
                padding-top:4rem;
            }

            h1 {
                color:white;
                text-transform: uppercase;
                text-shadow: 1px 1px #333;
                display: inline-block;
            }
            > div {
                display: inline-block;
                padding:.5rem 1rem;

                &.active {
                    color:#9c554b;
                }

                &:before{
                    counter-increment: progress-counter +1;
                    content: counter(progress-counter) ;
                    background-color: white;
                    color: #654a45;
                    padding:0.1rem .5rem;
                    border-radius:50%;
                    border:1px gray solid;
                    margin-right:0.5rem;
                }
            }
        }

        .form {
            .other-country {
                font-size:0.8rem;
                margin-left:0.5rem;
                width: 140px;
                line-height: 0.7rem;
                vertical-align: middle;
                display: inline-block;
            }

            ul {
                margin:auto;
                padding:0;
                list-style: none;
            }

            @media (min-width: 42em) {
                display: flex;
                flex: 100%;

                input, select {
                    line-height: 1rem;
                    overflow: hidden;
                }
                li {
                    &:nth-of-type(1) input {width:238px;}
                    &:nth-of-type(2) input,
                    &:nth-of-type(3) input,
                    &:nth-of-type(4) input,
                    &:nth-of-type(7) input,
                    &:nth-of-type(8) input,
                    &:nth-of-type(9) input,
                    &:nth-of-type(10) input,
                    {width:310px;}

                    &:nth-of-type(6) {
                        input:nth-of-type(1){width:80px;}  // zip
                        input:nth-of-type(2) {;width:174px;}  // city
                    }
                }
                textarea {width:320px;}

                label {
                    display: inline-block;
                    width :230px;
                    text-align: right;
                    margin-right:0.5rem;
                    &:after {
                        margin-left: .2rem;
                        content:' : ';
                    }
                }
            }
            @media (max-width: 42em) {      // vue smartphone
                li {
                    white-space: nowrap;
                }
                span.city {
                    display: block;
                    margin-top:0.5rem;
                }
                label {
                    display: block;
                    margin-top:0.5rem;
                    &:after {
                        content:' : ';
                    }
                }
                li {
                    input, textarea {
                        width:100%;
                        display: block;
                    }
                    select {
                        display: block;
                        &:nth-of-type(0) {
                            width:auto;
                        }
                        &:nth-of-type(1) {
                            width:100%;
                        }
                    }
                }
            }
        }

        section.actions {
            display: block;
            height: 1rem;
            margin-top:1rem;
            .submit.next {
                float: right;
            }
            .submit.prev {
                float: left;
            }
        }

        .error {
            text-align: center;
            .msg {
                border:1px #FF5555 solid;
                padding: .5rem .5rem .5rem 2rem;
                margin: 1rem auto;
                display: inline-block;
                background-size: 1rem; background-position: .5rem .5rem;
                background-repeat: no-repeat; background-image: url('../assets/error.svg');
                background-color: #FFFCFC;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/BillingAddressPage.vue